//import * as Zulamodule from "./module_exports";

export const apiHash = {
    dataset_init:process.env.REACT_APP_API_URL + "/dataset/init",
    dataset_getall:process.env.REACT_APP_API_URL + "/dataset/getall",
    dataset_search:process.env.REACT_APP_API_URL + "/dataset/search",
    dataset_list:process.env.REACT_APP_API_URL + "/dataset/list",
    dataset_detail:process.env.REACT_APP_API_URL + "/dataset/detail",
    dataset_download:process.env.REACT_APP_API_URL + "/dataset/download",
    dataset_upload:process.env.REACT_APP_API_URL + "/dataset/upload",
    dataset_submit:process.env.REACT_APP_API_URL + "/dataset/submit",
    dataset_glycan_finder:process.env.REACT_APP_API_URL + "/dataset/glycan_finder",
    dataset_history_list:process.env.REACT_APP_API_URL + "/dataset/historylist",
    dataset_history_detail:process.env.REACT_APP_API_URL + "/dataset/historydetail",
    dataset_static_content:process.env.REACT_APP_API_URL + "/dataset/pagecn",
    gsd_submit:process.env.REACT_APP_API_URL + "/gsd/submit"

};


